declare var $: any;

export class Foldout {
    static init() {
        $(document).on("click", ".js-foldout-toggle", Foldout.toggleFoldout);
    }

    static toggleFoldout(e: Event) {
        e.preventDefault();
        
        const foldout = $(e.currentTarget).parents(".foldout");
        foldout.toggleClass("foldout--open");
        const blind = foldout.find(".foldout-blind");

        if (foldout.hasClass("foldout--open")) {
            blind.slideDown(250);
        } else {
            blind.slideUp(200);
        }
        $(".foldout").trigger("foldout");
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/components/foldout.ts